const $inject = ['$rootScope', '$q', '$http', '$httpParamSerializer'];

const microApiService = function ($rootScope, $q, $http, $httpParamSerializer) {
  const service = {
    get,
    put,
    post
  };

  function refreshToken(cb, params) {
    console.log('refreshToken');
    $http({
      method: 'POST',
      url: 'https://travelctm-au-development.au.auth0.com/oauth/token',
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        grant_type: 'client_credentials',
        client_id: 'X2i2y5NUbMvMatQbJfcGPwuAUtmprgml',
        client_secret: 'aw0H79pjb0qREY9zNmLFsMHrjL1QgFY4ChHHa4oG1760T7vqRg0KCZWJtxIUrgrX',
        audience: 'http://debtor'
      }
    }).then(response => {
      sessionStorage.setItem('microServiceToken', response.data.access_token);
      cb(params);
    });
  }

  function get(params) {
    $rootScope.$broadcast('lbaLoader:loaderState', {state: 'loading'});
    const microServiceToken = sessionStorage.getItem('microServiceToken');

    if (!microServiceToken)
      refreshToken(get, params);

    $http({
      method: 'GET',
      url: `https://debtor-dev.ctmdevelopment.com/v1/${params.endpoint}`,
      headers: {
        'Authorization': `Bearer ${microServiceToken}`,
        'Content-Type': 'application/json'
      }
    }).then(response => {
      $rootScope.$broadcast('lbaLoader:loaderState', {state: 'loaded'});

      params.cb(response) }, error => {
      if (error.status === 401) {
        refreshToken(params)
      }
      console.log(error)
    });
  }

  function put(params) {
    $rootScope.$broadcast('lbaLoader:loaderState', { state: 'saving' });
    
    const microServiceToken = sessionStorage.getItem('microServiceToken');

    if (!microServiceToken)
      refreshToken(put, params);

    $http({
      method: 'PUT',
      url: `https://debtor-dev.ctmdevelopment.com/v1/${params.endpoint}`,
      headers: {
        'Authorization': `Bearer ${microServiceToken}`,
        'Content-Type': 'application/json'
      },
      data: params.data
    }).then(response => {
      $rootScope.$broadcast('lbaLoader:loaderState', { state: 'saved' });

      params.cb(response)
    }, error => {
      if (error.status === 401) {
        refreshToken(put, params)
      }
      console.log(error)
    });
  }

  function post(params) {
    $rootScope.$broadcast('lbaLoader:loaderState', { state: 'saving' });

    const microServiceToken = sessionStorage.getItem('microServiceToken');

    if (!microServiceToken)
      refreshToken(post, params);

    $http({
      method: 'POST',
      url: `https://debtor-dev.ctmdevelopment.com/v1/${params.endpoint}`,
      headers: {
        'Authorization': `Bearer ${microServiceToken}`,
        'Content-Type': 'application/json'
      },
      data: params.data
    }).then(response => {
      $rootScope.$broadcast('lbaLoader:loaderState', { state: 'saved' });

      params.cb(response)
    }, error => {
      if (error.status === 401) {
        refreshToken(post, params)
      }
      console.log(error)
    });

  }

  return service;
};

microApiService.$inject = $inject;

export default microApiService;



// WEBPACK FOOTER //
// ./src/services/microApiService.js